import React from 'react';

function EditIcon({disabled = false}) {
  return (
    <svg width="20" height="22" version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 20 22" enableBackground="new 0 0 20 22">
      <title>Edit</title>
      <path
        fill={disabled ? "#D7D7D6" : "#0D47A1"}
        d="M15,7.9L11.5,5l1.9-2.3c0.4-0.6,0.5-0.6,1.1-0.1l2.3,1.9c0.6,0.5,0.6,0.5,0.1,1.1L15,7.9 L15,7.9z M7.9,16.6c-1.2-1-3.2-2.6-3.5-2.8l6.1-7.6L14,9L7.9,16.6L7.9,16.6z M2.7,19.4l0.7-4.5l3.5,2.8L2.7,19.4L2.7,19.4z M18.3,3.8l-3.5-2.8c-0.7-0.6-1.5-0.5-2.1,0.2l-10.5,13l-1,6c-0.1,0.8,0.4,1.2,1.2,0.9L8,18.8l10.5-13C19.1,5.2,19,4.4,18.3,3.8 L18.3,3.8z"
      />
    </svg>
  );
}

export default EditIcon;



// WEBPACK FOOTER //
// ./src/components/icons/EditIcon.js